import { TonConnectUIProvider, THEME } from "@tonconnect/ui-react";
import { ReactNode, useEffect } from "react";

interface Props {
    children: ReactNode;
}

export function TonProvider({ children }: Props) {
    // Use absolute URL for manifest based on environment
    const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // Use localtunnel public URL for dev (TonKeeper uses tonapi.io proxy which can't access localhost)
    const manifestUrl = isDev 
        ? 'https://51b8-94-176-211-230.ngrok-free.app/tonconnect-manifest-local.json'
        : `${window.location.origin}/tonconnect-manifest.json`;

    return (
        <TonConnectUIProvider 
            manifestUrl={manifestUrl}
            uiPreferences={{ theme: THEME.DARK }}
            actionsConfiguration={
                // Только для production - на localhost может вызывать ERR_CLEARTEXT_NOT_PERMITTED в Telegram WebApp
                isDev ? undefined : {
                    twaReturnUrl: window.location.origin
                }
            }
        >
            {children}
        </TonConnectUIProvider>
    );
}
